import { render } from "./post-smtp-widget.vue?vue&type=template&id=61b1c642&scoped=true"
import script from "./post-smtp-widget.vue?vue&type=script&lang=js"
export * from "./post-smtp-widget.vue?vue&type=script&lang=js"

import "./post-smtp-widget.vue?vue&type=style&index=0&id=61b1c642&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61b1c642"]])

export default __exports__